import { defineMessages, IntlShape } from "react-intl";

import { getDisplayName } from "./getDisplayName";

type DataType = "count" | "other" | "value";

export const messages = defineMessages<DataType>({
  count: {
    id: "boundaryLegendWizard.steps.chooseType.fields.type.count.title",
    defaultMessage: "Count of Records",
    description:
      "Title of the Count data type option in Choose Step step in Boundary Legend wizard",
  },
  other: {
    id: "boundaryLegendWizard.steps.chooseType.fields.type.other.title",
    defaultMessage: "Other",
    description:
      "Title of the Other data type option in Choose Step step in Boundary Legend wizard",
  },
  value: {
    id: "boundaryLegendWizard.steps.chooseType.fields.type.value.title",
    defaultMessage: "Record Field Calculations",
    description: "Title of the Value type option in Choose Step step in Boundary Legend wizard",
  },
});

const getBoundaryLegendDataTypeDisplayName = (intl: IntlShape, type: DataType) =>
  getDisplayName(intl, messages, type, "DataType");

export default getBoundaryLegendDataTypeDisplayName;
